// @generated — do not edit manually. Run `generate-build-info` to regenerate.
export const buildInfo = {
  version: '1.1.2',
  commitHash: 'f65578e',
  localUsername: 'github',
} as const;
